// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  UpdateItemPricingParameters,
  UpdateItemPricingResponse,
  updateItemPricing,
} from '@/items/api/update-item-pricing';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface UseUpdateItemPricingOptions {
  itemKey: string;
  onSuccess?: (data: UpdateItemPricingResponse) => void;
}

export function useUpdateItemPricing(options: UseUpdateItemPricingOptions) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (parameters: UpdateItemPricingParameters) =>
      updateItemPricing(options.itemKey, parameters),
    onSuccess: (data) => {
      queryClient.setQueryData(['item', options.itemKey], {
        item: data.item,
        metadata: data.metadata,
      });
      options.onSuccess?.(data);
    },
  });
}
